import { authFetch } from '@/utils/auth-fetch';

export interface ValueEvidenceDimension {
  dimensionName: string;
  data: Record<string, any>;
  dataPoints: number;
  summary: string;
}

export interface ValueEvidenceReport {
  siteId: string;
  generatedAt: string;
  dimensionsCompleted: number;
  dimensionsTotal: number;
  dimensions: ValueEvidenceDimension[];
}

export interface ValueEvidenceHistoryEntry {
  id: number;
  site_id: string;
  dimensions_completed: number;
  generated_at: string;
  generated_by: string;
}

export interface StoredReport {
  id: number;
  site_id: string;
  report_data: ValueEvidenceReport;
  dimensions_completed: number;
  generated_at: string;
  generated_by: string;
}

class ValueEvidenceService {
  async getLatestReport(siteId: string): Promise<StoredReport | null> {
    const res = await authFetch(`/api/value-evidence/${siteId}`);
    if (res.status === 404) return null;
    if (!res.ok) throw new Error(`Failed to fetch report: ${res.statusText}`);
    return res.json();
  }

  async generateReport(siteId: string): Promise<ValueEvidenceReport> {
    const res = await authFetch(`/api/value-evidence/${siteId}/generate`, {
      method: 'POST'
    });
    if (!res.ok) throw new Error(`Failed to generate report: ${res.statusText}`);
    return res.json();
  }

  async getHistory(siteId: string, limit = 10): Promise<ValueEvidenceHistoryEntry[]> {
    const res = await authFetch(`/api/value-evidence/${siteId}/history?limit=${limit}`);
    if (!res.ok) throw new Error(`Failed to fetch history: ${res.statusText}`);
    const data = await res.json();
    return data.reports;
  }
}

export const valueEvidenceService = new ValueEvidenceService();
